var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"quesbox"},[_c('div',{staticClass:"ques"},[_c('span',[_vm._v("问")]),_vm._v(_vm._s(_vm.quesTitle)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"ans",domProps:{"innerHTML":_vm._s(_vm.quesContent)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68c8fe36","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/answer.vue
// module id = null
// module chunks = 